'use client';
var classes = {"monthsList":"m_2a6c32d","monthsListCell":"m_fe27622f"};

export { classes as default };
//# sourceMappingURL=MonthsList.module.css.mjs.map
